export default {
  title: 'Undtagelser fra åbningstider',
  fields: {
    status: {
      label: 'Status',
    },
    date: {
      label: 'Dato',
    },
    description: {
      label: 'Årsag',
    },
    recurring: {
      label: 'Gentages årligt',
    },
    created: {
      label: 'Oprettet',
      creator: 'af {{name}}',
    },
    updated: {
      label: 'Opdateret',
    },
  },
  status: {
    closed: 'Lukket',
    open: 'Åben',
    paused: 'Sat på pause',
  },
  date: {
    all_day: 'Hele dagen',
    paused_until_rest_of_day: 'På pause resten af dagen',
  },
  buttons: {
    pause_availability: '+ Sæt tilgængelighed på pause',
    close_availability: '+ Luk tilgængelighed',
    amend_availability: '+ Ret tilgængelighed',
    sync_from_online_shop: 'Synkroniser fra onlineshop',
    close: 'Luk',
    delete: 'Slet',
  },
  projects: {
    online_shop: 'Onlineshop',
    reservations: 'Reservationer',
    storefront: 'Butiksfacade',
  },
  error_messages: {
    delete_failed: 'Sletningen mislykkedes. Prøv igen.',
  },
  toasts: {
    sync_success: 'Synkroniseret',
    sync_error: 'Undtagelserne kunne ikke synkroniseres fra onlineshoppen. Prøv igen.',
  },
};
